import { render, staticRenderFns } from "./ShiftStats.vue?vue&type=template&id=6e0fe85d&scoped=true&"
import script from "./ShiftStats.vue?vue&type=script&setup=true&lang=js&"
export * from "./ShiftStats.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ShiftStats.vue?vue&type=style&index=0&id=6e0fe85d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0fe85d",
  null
  
)

export default component.exports